<template>
  <div class="page">
    <component
      v-for="(component, i) in $store.state.currentPage"
      :key="`${component.componentName}-${i}`"
      :is="component.componentName"
      :data="component.data"
      :class="[
        'app-component',
        component.data !== undefined && component.data.bgColored ? 'app-component--colored' : false,
      ]"
    />
    <AppFooter />
  </div>
</template>

<script>
import { TweenMax, ScrollToPlugin, Power4 } from 'gsap/all';

import PageHero from '@/components/PageHero.vue';
import Intro from '@/components/Intro.vue';
import FullText from '@/components/FullText.vue';
import BigImage from '@/components/BigImage.vue';
import PhasesList from '@/components/PhasesList.vue';
import ContactInfo from '@/components/ContactInfo.vue';
import ContactForm from '@/components/ContactForm.vue';
import OnUs from '@/components/OnUs.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'appPage',

  components: {
    PageHero,
    Intro,
    FullText,
    BigImage,
    PhasesList,
    ContactInfo,
    OnUs,
    AppFooter,
    ContactForm,
  },

  mounted() {
    console.log(ScrollToPlugin);
    TweenMax.to(window, 0.01, { scrollTo: 0 });
    TweenMax.to(window, 1, { scrollTo: 400, ease: Power4.easeInOut, delay: 0.2 });

    const burger = document.querySelector('.burger');
    const menu = document.querySelector('[data-mobileMenu]');
    if (burger.classList.contains('close')) {
      burger.classList.remove('close');
      menu.setAttribute('data-mobileMenu', 'hidden');
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";

.page {
  section {
    padding: 0 0 40px 0;

    @include mq(ipadP) {
      padding: 0 0 80px 0;
    }
  }

  .app-component--colored {
    background-color: $color-brown2;
  }
}
</style>
